import React from 'react';
import { CheckmarkSharp } from 'react-ionicons';
import { FaCheck } from "react-icons/fa";
import { is } from 'date-fns/locale';
import { FRAMEWORK_ICON_TYPE } from 'src/shared/config/src';
import LocalImages from '../../../static'

type IProps = {
  label?: string, 
  content: string,
  children?: any, 
  isArrow?: boolean, 
  borderColor?: string,
  customLabelStyle?: string | Array<string>,
  customContainerStyle?: string | Array<string>,
  isStatement?: boolean,
  iconType?: string
}



const TierNode = ({ label, content, children = null, isArrow, borderColor, customLabelStyle, customContainerStyle, isStatement = false, iconType }: IProps) => {
  return (
    <>
      <div className={`observation-statement-item ${customContainerStyle ? customContainerStyle : ''} ${iconType ? 'pd-r-40': ''}`} style={{ borderColor: borderColor ? borderColor : (isStatement ? '#E2E2E2' : ''), borderWidth : (borderColor ? 1 : (isStatement ? 1 : '')), borderStyle: (borderColor ? 'solid' : (isStatement ? 'dashed' : '')), paddingLeft: !isStatement ? '10px' : '' }}>
        {
          isStatement ? 
          <div className="observation-statement-legend">
            {/* <CheckmarkSharp color={borderColor ? borderColor : '#000'} height="12px" width="12px" /> */}
            <FaCheck color={borderColor ? borderColor : '#000'} className='fs-12' />
          </div> : null
        }
        {label ? <div className={`fs-12 text-black fw-semibold ${customLabelStyle ? customLabelStyle : ''}`}>{label}</div> : null}
        <div className={`fs-12 text-black fw-regular position-relative ${customLabelStyle ? customLabelStyle : ''}`}>{content}</div>
        {
          iconType ?
            <div className='position-absolute end-10 top-5 w15'>
              <img 
                src={(iconType === FRAMEWORK_ICON_TYPE.FOUNDATION) ? LocalImages.foundationIcon : 
                  ((iconType === FRAMEWORK_ICON_TYPE.STEPS) ? LocalImages.footStepsIcon : LocalImages.triangleIcon)
                  } 
                alt="foot-step-icon" 
                className='w-100 h-100' 
              />
            </div> : null
        }
      </div>
      {children && 
        <div className='mg-l-15'>
          {children}
        </div>
      }
    </>
  );
};

export default TierNode;
